export default "__VITE_ASSET__a8224d14__"